import { render, staticRenderFns } from "./ExpulsionOrderList.vue?vue&type=template&id=13141cac&"
import script from "./ExpulsionOrderList.vue?vue&type=script&lang=ts&"
export * from "./ExpulsionOrderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports